/**
 * 提示语管理页面
 * 职责：管理各类AI提示语模板
 */
import React, { useState } from 'react';
import { Form } from 'antd';
import { PromptSidebar } from './components/PromptSidebar';
import { PromptToolbar } from './components/PromptToolbar';
import { PromptEditor } from './components/PromptEditor';
import { usePromptTemplate } from './hooks/usePromptTemplate';
import type { TemplateType } from '../../types/ai-analysis-types';

const PromptManagement: React.FC = () => {
    const [form] = Form.useForm();
    const [selectedType, setSelectedType] = useState<TemplateType>('single_analysis');
    const [collapsed, setCollapsed] = useState(false);

    const {
        loading,
        saving,
        handleSave,
        handleResetToDefault
    } = usePromptTemplate(selectedType, form);

    return (
        <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
            <PromptSidebar
                selectedType={selectedType}
                collapsed={collapsed}
                onTypeChange={setSelectedType}
                onCollapse={setCollapsed}
            />
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <PromptToolbar
                    selectedType={selectedType}
                    onSave={() => form.submit()}
                    onReset={handleResetToDefault}
                    saving={saving}
                />
                <PromptEditor form={form} loading={loading} onSave={handleSave} />
            </div>
        </div>
    );
};

export default PromptManagement;
